import { render, staticRenderFns } from "./areaRotate.vue?vue&type=template&id=c8555652&"
import script from "./areaRotate.vue?vue&type=script&lang=js&"
export * from "./areaRotate.vue?vue&type=script&lang=js&"
import style0 from "./areaRotate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports